export default __webpack_public_path__ + "static/media/graduate.b93207fc.jpg";